import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Certificate from './pages/Certificate';

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/certificate/:id" component={Certificate} />
      </Switch>
    </Router>
  );
};

export default App;